export default "__VITE_ASSET__BdlkZr2X__"